import { Component, OnDestroy, OnInit } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'
import { SEOService } from '@flowaccount/landing'
import { Pages } from '../../../models/blog.model'
import { TranslateService } from '@ngx-translate/core'
import { Subject, Subscription } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
@Component({
  selector: 'flowaccount-become-our-partner',
  templateUrl: './become-our-partner.component.html',
  styleUrls: ['./become-our-partner.component.scss'],
})
export class BecomeOurPartnerComponent implements OnInit, OnDestroy {
  page = Pages

  public ngUnSubScribe = new Subject()
  customHeader = {
    heading: 'BLOG_SWIPER_TOPIC.HEADING_BECOME-OUR-PARTNER',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL_BECOME-OUR-PARTNER',
  }

  public reviewSectionTextList = {
    title: 'REVIEWS_PARTNERS_FLOWACCOUNT.TITLE',
    detail: 'REVIEWS_PARTNERS_FLOWACCOUNT.DETAIL',
    button: 'REVIEWS_PARTNERS_FLOWACCOUNT.BTN',
  }
  public mockContent: object[]
  protected langchangeSubscription: Subscription
  constructor(
    public translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private seoService: SEOService,
    private meta: Meta,
  ) {
    this.setMeta()
    this.langchangeSubscription = this.translate.onLangChange.pipe(takeUntil(this.ngUnSubScribe)).subscribe((res) => {
      const setContent = res.lang === 'th' ? 'index' : 'noindex'
      this.meta.updateTag({ name: 'robots', content: setContent })
      this.setMeta()
    })
  }
  ngOnInit() {
    this.showMockContent()
  }

  setMeta() {
    this.titleService.setTitle(this.translate.instant('metatitle-become-our-partner'))
    this.seoService.createMetaTag(
      this.translate.instant('metatitle-become-our-partner'),
      this.translate.instant('metaDescription-become-our-partner'),
    )
    this.seoService.createOg(
      'https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/partner_header_v2.jpg',
      this.translate.instant('metatitle-become-our-partner'),
      this.translate.instant('metaDescription-become-our-partner'),
    )
  }

  ngOnDestroy() {
    this.ngUnSubScribe.next(undefined)
    this.ngUnSubScribe.complete()
  }
  showMockContent() {
    this.mockContent = [
      {
        link: '/partner-roadshow',
        alt: 'partner roadshow',
        image: 'https://flowaccountcdn.com/new_landing/image/roadshow/banner/roadshow-banner.png',

        imageWebp: 'https://flowaccountcdn.com/new_landing/image/roadshow/banner/roadshow-banner.webp',

        imageMobile: 'https://flowaccountcdn.com/new_landing/image/roadshow/banner/roadshow-banner-mobile.png',

        imageMobileWebp: 'https://flowaccountcdn.com/new_landing/image/roadshow/banner/roadshow-banner-mobile.webp',
      },
    ]
  }
}
